export const partOfferTypes = {
    USED: "used",
    NEW: "new",
};
